"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CustomerInterface_1 = require("../../../BusinessLogicLayer/CustomerInterface");
exports.default = {
    bodyCharacteristics: {
        belly: CustomerInterface_1.BELLY_CHARACTERISTIC.MUSCULAR,
        buttocks: CustomerInterface_1.BUTTOCKS_CHARACTERISTIC.MUSCULAR,
        calves: CustomerInterface_1.CALVES_CHARACTERISTIC.FIRM,
        chest: CustomerInterface_1.BREAST_CHARACTERISTIC.MUSCULAR_CHEST,
        hips: CustomerInterface_1.LEGS_CHARACTERISTIC.MUSCULAR,
        loveHandles: CustomerInterface_1.LOVE_HANDLES_CHARACTERISTIC.IN_PROPORTION,
        neck: CustomerInterface_1.NECK_CHARACTERISTIC.IN_PROPORTION,
        shoulders: CustomerInterface_1.SHOULDERS_CHARACTERISTIC.IN_PROPORTION,
        upperArms: CustomerInterface_1.UPPER_ARMS_CHARACTERISTIC.MUSCULAR,
        waist: CustomerInterface_1.WAIST_CHARACTERISTIC.IN_PROPORTION,
    },
    disc: {
        d: 29,
        i: 19,
        s: 28,
        c: 24,
    },
    hormone: [
        {
            name: "I",
            value: 7,
        },
        {
            name: "C",
            value: 6,
        },
        {
            name: "T",
            value: 7,
        },
        {
            name: "O",
            value: 4,
        },
    ],
    nutritionExperience: 19,
    questions: [
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heb je een eetstoornis(verleden)?",
        },
        {
            answer: "Ja",
            category: "MEDICAL",
            comment: "asdasd",
            question: "Heb je een allergie tegen bijv. pollen, medicatie of insecten?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heeft een arts je ooit een negatief sportadvies gegeven?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heb je gezondheidsproblemen?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Ben je onder behandeling van een arts, psycholoog, fysiotherapeut?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heb je momenteel een blessure? Zo ja, welke?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heb je operaties ondergaan?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Gebruik je medicijnen?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heb je een diëtist? Of volg je een dieet?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Drink je alcohol? Zo ja, hoeveel per week?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Drink je cafeïnehoudende dranken? Zo ja, hoe vaak per dag?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Rook je? Zo ja, hoeveel per dag?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Gebruik je andere geest verruimende middelen? Zo ja, hoe vaak?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Ben je ooit flauwgevallen tijdens of na inspanning?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Ben je ooit duizelig geworden tijdens of na inspanning?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heb je ooit pijn in de borststreek gehad tijdens of na inspanning?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heb je ooit hartkloppingen of -ritmestoornissen gehad?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Ben je sneller vermoeid dan je medesporters tijdens het sporten?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heb je ooit een hoge bloeddruk of hoog cholesterol gehad?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Is er iemand in je familie gestorven ten gevolge van hartproblemen?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heb je een erge virale infectie gehad (bv een hartspierenontsteking)?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heb je ooit huiduitslag of jeuk ontwikkeld tijdens inspanning?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heb je last van kortademigheid of andere ademhalingsproblemen?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heb je astma?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Neem je medicatie of gebruik je een inhalator?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Lijd je momenteel aan een ziekte of chronische aandoening?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Ben je ooit in het ziekenhuis opgenomen?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heb je langere tijd niet kunnen trainen door medische problemen?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heb je ooit een breuk of ontwrichting opgelopen?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heb je een aangeboren lichamelijke beperking?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Gebruik je letselpreventieve maatregelen (braces, steunzolen)?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Heb je weleens gevoelloosheid of tintelingen in je ledematen?",
        },
        {
            answer: "Nee",
            category: "MEDICAL",
            comment: null,
            question: "Gebruik je voedingssupplementen?",
        },
        {
            answer: "Licht Getint",
            category: "MEDICAL",
            comment: null,
            question: "Wat is je huidtype?",
        },
        {
            answer: null,
            category: "HABITS",
            comment: null,
            question: "Doe je aan sport? Zo ja, welke en hoe vaak per week?",
        },
        {
            answer: null,
            category: "HABITS",
            comment: null,
            question: "Wat beschrijft je levensstijl het beste?",
        },
        {
            answer: null,
            category: "HABITS",
            comment: null,
            question: "Wat beschrijft je thuissituatie het beste?",
        },
        {
            answer: null,
            category: "NUTRITION",
            comment: null,
            question: "Geef jezelf een waardering over je kennis en ervaring met voeding:",
        },
        {
            answer: null,
            category: "NUTRITION",
            comment: null,
            question: "Heb je ooit je voeding op langere termijn aangepast?",
        },
        {
            answer: null,
            category: "NUTRITION",
            comment: null,
            question: "Hoe is je kennis op het gebied van macronutriënten?",
        },
        {
            answer: null,
            category: "NUTRITION",
            comment: null,
            question: "Hoe is je kennis op het gebied van micronutriënten?",
        },
        {
            answer: null,
            category: "NUTRITION",
            comment: null,
            question: "Hoe is je kennis op het gebied van supplementen?",
        },
        {
            answer: null,
            category: "NUTRITION",
            comment: null,
            question: "Hoe is je kennis op het gebied van hormonen?",
        },
        {
            answer: null,
            category: "NUTRITION",
            comment: null,
            question: "Hoe is je kennis op het gebied van enzymen?",
        },
        {
            answer: null,
            category: "EXERCISES",
            comment: null,
            question: "Geef jezelf een waardering over je ervaring met krachttraining:",
        },
        {
            answer: null,
            category: "EXERCISES",
            comment: null,
            question: "Heb je op geregelde basis aan krachttraining gedaan?",
        },
        {
            answer: null,
            category: "EXERCISES",
            comment: null,
            question: "Hoe ervaren ben je met fitnessmachines?",
        },
        {
            answer: null,
            category: "EXERCISES",
            comment: null,
            question: "Hoe ervaren ben je met barbells?",
        },
        {
            answer: null,
            category: "EXERCISES",
            comment: null,
            question: "Hoe ervaren ben je met dumbbells?",
        },
        {
            answer: null,
            category: "EXERCISES",
            comment: null,
            question: "Hoe ervaren ben je met de swissball/bosubal?",
        },
        {
            answer: null,
            category: "EXERCISES",
            comment: null,
            question: "Hoe ervaren ben je met HIIT?",
        },
        {
            answer: "ja voll",
            category: "EXERCISES",
            comment: null,
            question: "Do You even lift?",
        },
    ],
    trainingExperience: 21,
    xQuestions: [
        {
            answer: "2 keer",
            question: "Hoe vaak per week wil je een training van PBP gaan doen?",
        },
        {
            answer: "@Gym",
            question: "Welke trainingslocatie heb je gekozen?",
        },
        {
            answer: "no",
            question: "Ben je al eerder begeleid door een (personal) trainer?",
        },
        {
            answer: "6-12 maanden",
            question: "Hoe lang doe je al aan krachttraining?",
        },
        {
            answer: "4",
            question: "*Hoe zwaar kun je squatten?*",
        },
        {
            answer: "4",
            question: "*Hoe zwaar kun je deadliften?*",
        },
        {
            answer: "4",
            question: "*Hoe zwaar kun je de bench press?*",
        },
        {
            answer: "4",
            question: "Hoeveel volledige pull-ups/chin-ups kun je doen?",
        },
        {
            answer: "Achterkant benen<br>Rug",
            question: "Wat zijn jouw sterkere spiergroepen?",
        },
        {
            answer: "Achterkant benen<br>Armen",
            question: "Wat zijn jouw zwakkere spiergroepen?",
        },
        {
            answer: "4",
            question: "Wat is je doelstelling met jouw Personal Fat Ripping Plan?",
        },
        {
            answer: "4",
            question: "Wat is je huidige gewicht?",
        },
        {
            answer: "4",
            question: "Wat is je lengte (in cm)?",
        },
        {
            answer: "no",
            question: "Heb jij op dit moment een blessure waar wij rekening mee moeten houden bij het maken van jouw programma?",
        },
        {
            answer: "4",
            question: "Hoe vaak per week doe je een andere sport naast krachttraining?",
        },
    ],
};
//# sourceMappingURL=intakeData.js.map